import { render, staticRenderFns } from "./ResponsesTableRow.vue?vue&type=template&id=5b46484c&scoped=true&"
import script from "./ResponsesTableRow.vue?vue&type=script&lang=js&"
export * from "./ResponsesTableRow.vue?vue&type=script&lang=js&"
import style0 from "./ResponsesTableRow.vue?vue&type=style&index=0&id=5b46484c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b46484c",
  null
  
)

export default component.exports